import React, { ReactNode } from 'react';
import {
  Icons,
  ToolButton,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Button,
} from '../';
import { IconPresentationProvider } from '@ohif/ui-next';

import NavBar from '../NavBar';

// Todo: we should move this component to composition and remove props base

interface HeaderProps {
  children?: ReactNode;
  menuOptions: Array<{
    title: string;
    icon?: string;
    onClick: () => void;
  }>;
  isReturnEnabled?: boolean;
  onClickReturnButton?: () => void;
  isSticky?: boolean;
  showSettingsMenu?: boolean;
  WhiteLabeling?: {
    createLogoComponentFn?: (React: any, props: any) => ReactNode;
  };
  PatientInfo?: ReactNode;
  Secondary?: ReactNode;
  UndoRedo?: ReactNode;
}

function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  showSettingsMenu = false,
  WhiteLabeling,
  PatientInfo,
  UndoRedo,
  Secondary,
  ...props
}: HeaderProps): ReactNode {
  return (
    <IconPresentationProvider
      size="large"
      IconContainer={ToolButton}
    >
      <NavBar
        isSticky={isSticky}
        {...props}
      >
        <div className="relative h-[48px] items-center">
          <div className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center">
            <div className="mr-3 inline-flex items-center">
              {/* Return-to-worklist arrow intentionally omitted in the Pacsifly UI. */}
              <div className="ml-1 hidden sm:block">
                {WhiteLabeling?.createLogoComponentFn?.(React, props) || <Icons.OHIFLogo />}
              </div>
            </div>
          </div>
          <div className="absolute top-1/2 left-[250px] h-8 -translate-y-1/2">{Secondary}</div>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
            <div className="flex items-center justify-center space-x-2">{children}</div>
          </div>
          <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center">
            <div className="hidden sm:block">{UndoRedo}</div>
            {/* PatientInfo is intentionally omitted in the Pacsifly UI. */}
            {showSettingsMenu && (
              <>
                <div className="border-muted mx-1.5 h-[25px] border-r"></div>
                <div className="flex-shrink-0">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="text-primary hover:bg-muted mt-2 h-full w-full"
                      >
                        <Icons.GearSettings />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      {menuOptions.map((option, index) => {
                        const IconComponent = option.icon
                          ? Icons[option.icon as keyof typeof Icons]
                          : null;
                        return (
                          <DropdownMenuItem
                            key={index}
                            onSelect={option.onClick}
                            className="flex items-center gap-2 py-2"
                          >
                            {IconComponent && (
                              <span className="flex h-4 w-4 items-center justify-center">
                                <Icons.ByName name={option.icon} />
                              </span>
                            )}
                            <span className="flex-1">{option.title}</span>
                          </DropdownMenuItem>
                        );
                      })}
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </IconPresentationProvider>
  );
}

export default Header;
